// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"272c3739","314":"19454915","453":"b073eb33","569":"b4dfbd91"}[chunkId] + ".chunk.js";
};